import {Trust} from "../../model/EstateFlowchartTypes";
import {isValid} from "../ValidationUtils";
import {ValidationError, ValidationErrorType} from "../ValidationTypes";

export const validateTrusts = (trusts: Trust[]): ValidationError[] => {
    let validationErrors = [] as ValidationError[];
    if (trusts && trusts.length > 0) {
        trusts?.forEach((trust) => {
            validateRequiredFields(trust, validationErrors);
        });
    }
    return validationErrors;
}

const validateRequiredFields = (trust: Trust, validationErrors: ValidationError[]) => {
    if (!isValid(trust.name)) validationErrors.push({
        type: ValidationErrorType.REQUIRED_FIELDS,
        property: 'trustName',
        parent: trust.name,
        error: "Trust Name is required."
    });
    if (!isValid(trust.tags)) validationErrors.push({
        type: ValidationErrorType.REQUIRED_FIELDS,
        property: 'tags',
        parent: trust.name,
        error: "Tags is required."
    });
    if (!isValid(trust.distributions)) validationErrors.push({
        type: ValidationErrorType.REQUIRED_FIELDS,
        property: 'distributions',
        parent: trust.name,
        error: "Distributions is required."
    });
    if (trust.trustees?.length === 0) validationErrors.push({
        type: ValidationErrorType.REQUIRED_FIELDS,
        property: 'trustees',
        parent: trust.name,
        error: "Trustees is required."
    });

    trust.powersOfAppointment?.forEach((poa, poaIndex) => {
        if (!isValid(poa.powerHolder)) validationErrors.push({
            type: ValidationErrorType.REQUIRED_FIELDS,
            property: 'powerHolder',
            parent: trust.name,
            error: "Power Holder is required."
        });
    })
}
